// extracted by mini-css-extract-plugin
export default {"inputField":"AcademyProjectDetails_inputField__ORjOg","input":"AcademyProjectDetails_input__iwEu7","fieldLabel":"AcademyProjectDetails_fieldLabel__1TQ3v"};